module.exports = __webpack_public_path__ + "img/Wandelstok of krukken.a22bf230.svg";